import * as components from "./ComponentDocs";
import * as filePluginUtils from "./CordovaFilePlugin";
import sendRequest from "./sendRequest";


export default {
    id:"cordovavritra",
    name:"cordova-vritra",
    docs:[
        ...Object.values(components),
        ...Object.values(filePluginUtils),
       /*  {
            id:"components",
            entries:Object.values(components),
        },
        {
            id:"CordovaFilePlugin",
            entries:Object.values(filePluginUtils),
        }, */
        sendRequest,
    ],
}
